export const formatOrganizationLabel = (name, email) => {
  if (name && email) {
    return `${name} (${email})`;
  }

  if (name) {
    return name;
  }

  if (email) {
    return email;
  }

  return '-';
};
